<div class="input-wrapper">
  <app-input
    (fieldCurrentValue)="getValue($event)"
    class="input-wrapper__input"
    classes="delete-margin"
    [maxLength]="maxLength"
    [fieldValue]="fieldValue"
    [placeholder]="placeholder">
  </app-input>

  <div 
    class="input-wrapper__icon"
    (click)="clearText()"
  >
    <svg-icon
      class="input-wrapper__icon-icon"
      [icon]="icon"
      [classes]="'a-img-18'"
      [isButtonIcon]="true">
    </svg-icon>
  </div>
</div>
